
import Cust_topbar from './Cust_topbar';

const CustLayout = ({ children }) => {
   return (
      <>
         <Cust_topbar />
         <div className="pt-16 xl:ml-64 p-4 bg-gradient-to-b from-lime-100 to-white min-h-screen">
            {children}
         </div>
      </>
   );
};

export default CustLayout;
